module.exports = __webpack_public_path__ + "img/childWoman.8c7627fb.png";